/*
  A short burst of confetti, for the two or three moments on this shop worth
  marking: an order landing, and a customer crossing into a discount.

  Its own file because both the cart and the checkout want it, and both are
  plain scripts with no way to share a function otherwise. It brings its own
  styles along so there is one place to change, not three.

  Hand-made out of a few dozen divs rather than a library: it runs for three
  seconds on a page that is already finished, and is not worth a download.

  Usage:  window.spConfetti()            a normal burst
          window.spConfetti({ pieces: 18 })   a smaller one
*/
(function () {
  'use strict';

  var STYLE_ID = 'sp-confetti-style';
  var COLOURS = ['#B8860B', '#E8B84B', '#0A7A38', '#D94F70', '#103948', '#F2C94C'];

  function addStyleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.sp-confetti{position:fixed;inset:0;overflow:hidden;pointer-events:none;z-index:9999}',
      '.sp-confetti i{position:absolute;top:-14px;width:9px;height:14px;border-radius:2px;',
      'animation-name:sp-confetti-fall;animation-timing-function:linear;animation-fill-mode:forwards}',
      '@keyframes sp-confetti-fall{',
      '0%{transform:translateY(0) rotate(0deg);opacity:1}',
      '100%{transform:translateY(105vh) rotate(540deg);opacity:.9}}',
      '@media (prefers-reduced-motion: reduce){.sp-confetti{display:none}}'
    ].join('');
    document.head.appendChild(style);
  }

  window.spConfetti = function (options) {
    var settings = options || {};
    var pieces = settings.pieces || 40;

    // Someone who has asked their phone to stop moving things has asked for
    // a reason, and a shop is not the place to argue.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    addStyleOnce();

    var sky = document.createElement('div');
    sky.className = 'sp-confetti';
    for (var i = 0; i < pieces; i++) {
      var bit = document.createElement('i');
      bit.style.left = (Math.random() * 100).toFixed(2) + '%';
      bit.style.background = COLOURS[i % COLOURS.length];
      bit.style.animationDelay = (Math.random() * 0.6).toFixed(2) + 's';
      bit.style.animationDuration = (2.2 + Math.random() * 1.4).toFixed(2) + 's';
      bit.style.transform = 'rotate(' + Math.floor(Math.random() * 360) + 'deg)';
      sky.appendChild(bit);
    }
    document.body.appendChild(sky);
    setTimeout(function () {
      if (sky.parentNode) sky.parentNode.removeChild(sky);
    }, 4500);
  };
})();
